import React, { useState, useEffect } from "react";
import styles from "./Service.module.css";
import { Link, useLocation } from "react-router-dom";
import Offer from "./Offer";

export default function Service() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(
    () => {
      const handleAnchorClick = e => {
        const target = e.target.closest('a[href^="/#"]');
        if (target && isMenuOpen) {
          closeMenu();
        }
      };

      document.addEventListener("click", handleAnchorClick);
      return () => document.removeEventListener("click", handleAnchorClick);
    },
    [isMenuOpen]
  );

  const location = useLocation();
  useEffect(
    () => {
      // Jeśli w URL jest hash (np. /#gallery, /#contact)
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth"
          });
        }
      } else {
        // Jeśli nie ma hasha (np. po prostu /), przewiń na samą górę
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    },
    [location]
  ); // uruchamia się za każdym razem, gdy zmienia się URL

  return (
    <section id="service" className="sectionContainer dark">
      <div className="sectionTitle">
        <h2>W czym możemy Ci pomóc?</h2>
      </div>
      <div className={styles.serviceContent}>
        <Link to="/web" onClick={closeMenu} className={styles.serviceItem}>
          <h3 className={styles.serviceTitle}>Tworzenie stron internetowych</h3>
          <p className={styles.serviceDescribe}>
            Projektujemy i kodujemy proste, funkcjonalne oraz estetyczne strony
            WWW. Dbamy o przejrzystość, intuicyjną nawigację i responsywność,
            aby Twoja strona działała sprawnie na każdym urządzeniu. Każdy
            projekt przygotowujemy indywidualnie, bez gotowych szablonów,
            dopasowując go do potrzeb Twojej firmy.
          </p>
          <Offer message="Kodujemy od podstaw • Projektujemy indywidualnie • Dbamy o responsywnoś" />
        </Link>
        <Link to="/training" onClick={closeMenu} className={styles.serviceItem}>
          <div>
            <h3 className={styles.serviceTitle}>Szkolenia informatyczne</h3>
            <p className={styles.serviceDescribe}>
              Prowadzimy indywidualne oraz grupowe szkolenia informatyczne
              dopasowane do poziomu wiedzy i potrzeb uczestników. Niezależnie od
              tego, czy zaczynasz swoją przygodę z komputerem, czy chcesz
              rozwinąć swoje umiejętności, pomożemy Ci zdobyć praktyczną wiedzę
              w przyjaznej atmosferze.
            </p>
          </div>
          <Offer message="Praktyczna wiedza • Indywidualne podejście • Nauka bez stresu" />
        </Link>
      </div>
    </section>
  );
}
